export const customManagement = {
  SHAREMESSAGECONTAINER: "/sharemessagecontainer",
  ADDOFFER: "/addOffers",
  APPOINMENTDASHBOARD: "/appoinmentDashboard",

  SHARESESSAGE: "/shareMessage",
  MYBUSSINESS: "/myBusiness",
  CUSTOMERINFORMATION: "/customerInformation",
  SHARERATECARD: "/shareratecart",
  MyInstitute: "/myinstitute",
  Enquiries: "/enquiries",
  MyFranchise: "/myfranchise",
  WHITELABELS: "/whiteLables",
};

export const adminRoutes = {
  ADVERTISEMENT: "/advertisement",
  RECHARGE: "/recharge",
  RECHARGEREPORT: "/recharge-report",
  OFFERS: "/offers",
  USERPROFILEC: "/user-profile-list",
  REPORTSTAB: "/reports-tab",
};
export const billerRoute = {
  COUNTERSELL: "/countersale",
  OLDCOUNTERSELL: "/oldcountersale",
};
export const bussinessMangementMenuRoute = {
  EXPENCE: "/expence",
  INVENTORY: "/inventory",
  ITEMSERVICES: "/itemServices",
  EMPLOYEEINFO: "/employeeInfo",
  OUTSTANDINGREPORT: "/outstandingReport",
  EMPLOYEEATTENDANCE: "/employeeAttendance",
  ASSOCIATEDUSERS: "/associatedUsers",
  EMPLOYEEPAYROLL: "/employeePayroll",
  PAYMENTSTRUCT: "/paymentStruct",
  PURCHASEMANAGMENT: "/purchaseManagement",
  SHAREMESSAGEPROFILE: "/shareEmployeeProfile",
  BULTMESSAGE: "/bulkMessage",
  BLUESERIVE: "/bulkService",
  JOBHIRINGPOST: "/jobhiringpost",
};
export const analaticsRoute = {
  DASHBOARD: "/dashboard",
  REPORTS: "/reports",
  TOTALCOUNTERSELLREPORT: "/reports/totalcountersalereport",
  ITEMCATEGORIESWISEDAILYCOUNTERSALTES:
    "/reports/Itemcategorywisedailycountersales",
  ITEMSWISECOUNTERSALEREPORT: "/reports/itemwisecountersalereport",

  GSTREPORT: "/reports/gstreport",
  RAWMATERIALREPORTS: "/reports/rowmaterialreports",
  COUNTERSALEOFSELECTEDITEMS: "/reports/countersaleofselecteditems",

  DISOCUNTINUEDITEM: "/reports/DiscountinueditemsServiceslist",
  LISTOFITEMSSERVICES: "/reports/listofitemsservices",
  INVENTORYREPORTS: "/reports/inventoryreports",

  PURCHASEREPORTS: "/reports/purchasereports",
  EXPENSEREPORTS: "/reports/expensereports",
  ITEMCATEGORY: "/reports/itemcatogery",

  EMPLOYEEADVANCEPAYMENTREPORT: "/reports/employeeadvancepaymentreport",
  EMPLOYEEPAYROLLREPORT: "/reports/employeepayrollreport",
  EMPLOYEEDETAILREPORT: "/reports/employeedetailreport",
  CUSTOMERINFOREPORT: "/reports/customerinforeport",
  CUSTOMERHISTORYREPORT: "/reports/customerhistoryreport",
  CUSTOMERAPPOINTMENTREPORT: "/reports/customerappointmentreport",
};
export const routePath = {
  ROOT: "/",
  LANDINGPAGE: "/",
  WHATISELEGANTPRIME: "/whatIsElegantprime",
  SERVICES: "/services",
  REVIEWANDRATING: "/ReviewAndRating/:id",
  ADVERTICE: "/advertice",
  LANDINGPAGEHOME: "/homepage",

  SERVICESLIST: "/ServicesList",
  COURSES: "/courses",
  JOBS: "/jobs",
  FRANCHISE: "/franchiseList",
  JOBSLIST: "/jobfilter",
  MYJOBPROFILE: "/myjobprofile",
  EDITPROFILE: "/editprofile",
  APPOINMENT: "/appoinment",
  OTPFORGET: "/otpforget",
  REGISTRATION: "/REGISTRATION",
  OTPAPPOINMENT: "/otpappoinment",

  OTP: "/otp",
  SETMPIN: "/setMpin",
  USERPROFILE: "/userprofile",
  LANDINGPAGERESTORENT: "/restorant",
  FAV: "/fav",
  APPLYJOB: "/apply/:id",
  COURSEDETAILS: "/coursedetails/:id",
  INSTITUTEINFO: "/instituteInfo/:id",
  FRANCHISEDETAILS: "/franchiseDetails/:id",
  LANDINGPAGECOUNTERTOKEN: "/token",
  DETAIL: "/detail",
  LANDINGPAGEMONTHLYBILL: "/monthlybill",
  LANDINGPAGEFRANCHISE: "/franchise",
  LOGIN: "/login",
  CUSTOMERLOGIN: "/customerlogin",

  ADVANCEPAYMENT: "/advancepayment",
  COUNTERSELLBILLING: "/countersellbilling",
  MYPROFILE: "/myprofile",
  MYBUSSINESS: "/myBusiness",
  TABLEMASTER: "/tablemaster",

  OLDUPDATEBILLS: "/oldupdatebills",
  UPDATEBILLS: "/updatebills",
  TABLESECTION: "/table-section",
  ITEMCATEGORIES: "/item-categories",
  PAYMENTRECEIPT: "/payament-receipt",
  MOBILEPAGEMENU: "/mobil-emenu-Page",

  SMBACCOUNTREACHARGE: "/account-recharge",
  ITEMWISESALE: "/item-wise-sale",
  STOCKS: "/stocks",
  PURCHASE: "/purchase",
  HELPSUPPORT: "/help-support",

  RESETMPIN: "/reset-mpin",
  SETTING: "/printerSetting",
  RATECHANGE: "/rate-change",
  CASHCOUNTERSALE: "/cash-counter-sale",
  KYCPROCESS: "/kyc-process",

  PRIVACYPOLICY: "/privacyPolicy",
  TERMSOFSERVICE: "/termsOfService",
  GETOFFERBYBILLER: "/getUserOffer",
  SALARY: "/salary",

  ASSISTANTLOGIN: "/assistant-login",
  SALON: "/salon",
  DETAILS: "/details",
  PROFILEPAGE: "/profile",
  APPOINMENTPAGEE: "/appoinmentsss",
  FAVOURITEPAGE: "/favourite",

  COMPANYUSELOGIN: "/admin",
  ADVERTISEMENTTOOLS: "/advertisementTools",
  RECHARGETOOLS: "/rechargeTools",
  SUPPORTTOOLS: "/supportTools",

  ...customManagement,
  ...analaticsRoute,
  ...bussinessMangementMenuRoute,
  ...billerRoute,
  ...adminRoutes,
};
